import InventoriesConfig from './tables-configs/inventories.json';
import RefrigeratorsConfig from './tables-configs/refrigerators.json';
import {ActivatedRoute} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {CommonService} from '../services/common.service';
import {Component, OnInit} from '@angular/core';
import {Details} from '../details/details';
import {EventLogsService} from '../services/event-logs.service';
import {LoadingService} from '../services/loading.service';
import {MatTabGroup} from '@angular/material/tabs';
import {SalePointsService} from '../services/sale-points.service';
import {ToastMessagesService} from '../services/toast-messages.service';
import {MatDialog} from '@angular/material/dialog';
import {CreateReturnRequestDialogComponent} from './create-return-request-dialog/create-return-request-dialog.component';
import {CreateRefrigeratorRequestDialogComponent} from './create-refrigerator-request-dialog/create-refrigerator-request-dialog.component';
import {ActionCompletionDialogComponent} from '../common/action-completion-dialog/action-completion-dialog.component';
import {
  SimpleConfirmActionDialogComponent
} from '../common/simple-confirm-action-dialog/simple-confirm-action-dialog.component';
import {Router} from '@angular/router';

@Component({
  templateUrl: './sale-point-details.component.html'
})
export class SalePointDetailsComponent extends Details implements OnInit {
  public basicDetailsConfig: any;
  public eventLogs: any[];
  public id: number;
  public initializePage: boolean;
  public inventoriesConfig: any;
  public mainDataSections: any[];
  public refrigeratorsConfig: any;
  public salePoint: any;

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              private commonService: CommonService,
              private eventLogsService: EventLogsService,
              private loadingService: LoadingService,
              private matDialog: MatDialog,
              private salePointsService: SalePointsService,
              private toastMessagesService: ToastMessagesService,
              private router: Router) {
    super();

    this.inventoriesConfig = InventoriesConfig;
    this.eventLogs = [];
    this.refrigeratorsConfig = RefrigeratorsConfig;
  }

  public async ngOnInit(): Promise<void> {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.id = +params.get('id');
      let promises: Array<Promise<any>>;

      promises = [];

      const promise1 = this.salePointsService.getSingleSalePoint(+params.get('id')).then((salePoint) => {
        this.salePoint = salePoint;
      });

      promises.push(promise1);

      Promise.all(promises).then(() => {
        this.inventoriesConfig.filter = 'sale_point_id = ' + this.salePoint.id;

        this.refrigeratorsConfig.filter = 'sale_point_id = ' + this.salePoint.id;
        this.basicDetailsConfig = {
          showActions: this.showActions(),
          status_name: this.salePoint.is_active ? 'Ενεργό' : 'Ανενεργό',
          status_value: this.salePoint.is_active,
          subtitle: [
            {
              title: 'Α.Φ.Μ.',
              value: this.salePoint.vat_number
            }
          ],
          title: `Πληροφορίες Σημείου Πώλησης: ${this.salePoint.customer_name}`
        };

        this.mainDataSections = this.salePointsService.initializeSalePoint(this.salePoint);
        this.initializeActions();
        this.initializePage = true;

        this.loadingService.hide();
      });
    });
    if (this.showEventLogs()) {
      const eventLogs = await this.eventLogsService.getSalePointEventLogs(this.id);
      this.eventLogs = eventLogs;
    }
  }

  private async initializeActions() {
    const deactivateSPEventLogExists = this.eventLogs.find(eventLog => eventLog.log_type_id === 7);
    const actions = [];

    const action1 = {
      function: () => {
        this.downloadPDF();
      },
      showAction: true,
      title: 'Λήψη PDF',
      icon: 'picture_as_pdf',
      color: '#013e81',
    };
    actions.push(action1);

    // add second action approval

    if ( deactivateSPEventLogExists &&
      ( this.authService.isUserBelongsTo('basicUser') || this.authService.isUserBelongsTo('customerManager')) ) {
      const action2 = {
        function: () => {
          this.approval();
        },
        showAction: true,
        title: 'Διαδικασία απενεργοποίησης Σημείου Πώλησης',
        icon: 'done',
        color: '#013e81',
      };
      actions.push(action2);
    }

    if ( !deactivateSPEventLogExists && this.salePoint.is_active &&
      ( this.authService.isUserBelongsTo('basicUser') || this.authService.isUserBelongsTo('customerManager')) ) {
      const action3 = {
        function: () => {
          this.deactivateSalePoint();
        },
        showAction: true,
        title: 'Aπενεργοποίηση Σημείου Πώλησης',
        icon: 'visibility_off',
        color: '#013e81',
      };
      actions.push(action3);
    }

    if ( !this.salePoint.is_active &&
      ( this.authService.isUserBelongsTo('basicUser') || this.authService.isUserBelongsTo('customerManager')) ) {
      const action3 = {
        function: () => {
          this.enableSalePoint();
        },
        showAction: true,
        title: 'Ενεργοποίηση Σημείου Πώλησης',
        icon: 'visibility',
        color: '#013e81',
      };
      actions.push(action3);
    }

    if ((this.authService.isUserBelongsTo('basicUser') || this.authService.isUserBelongsTo('hqManager'))
      && this.salePoint.key_account_id !== null) {
      let action;
      action = {
        function: () => {
          this.openCreateReturnRequestDialog();
        },
        showAction: true,
        title: 'Δημιουργία εντολής επιστρ. ψυγείου',
        icon: 'assignment',
        color: '#013e81',
      };
      actions.push(action);

      action = {
        function: () => {
          this.openRefrigeratorRequestDialog();
        },
        showAction: true,
        title: 'Δημιουργία αίτησης ψυγείου',
        icon: 'assignment',
        color: '#013e81',
      };
      actions.push(action);
    }

    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = true;
    } else {
      this.basicDetailsConfig.showActions = false;
    }
  }

  public changeTab(tabs: MatTabGroup): void {
    if (tabs.selectedIndex !== 0) {
      // this.loadingService.show();
    }
  }

  async downloadPDF() {
    try {
     const fileName = this.salePoint.customer_name.split('.').join('_');
     await this.commonService.getPDF(`sale_point/PDF/${this.salePoint.id}`, `ΣΠ - ${fileName}`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async approval() {
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: 'Διαδικασία απενεργοποίησης Σημείου Πώλησης',
        message: `Εγκρίνετε την απενεργοποιήση του συγκεκριμένου Σημείου Πώλησης;`
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          const result1 = await  this.commonService.updateObject(`sale_point/approval_deactivation`,
            {sale_point_id: this.salePoint.id, notification_id: this.eventLogs[0].id});
          if (result1) {
            this.matDialog.open(ActionCompletionDialogComponent, {data: {}});
          }
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      } else {
          try {
            const result1 = await this.commonService.updateObject(`sale_point/reject_deactivation`,
              {notification_id: this.eventLogs[0].id});
            if (result1) {
              this.matDialog.open(ActionCompletionDialogComponent, {data: {}});
            }
          } catch (e) {
              this.toastMessagesService.toastErrorMessage(e.message);
            }
      }
    });
  }

  async deactivateSalePoint() {
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: 'Aπενεργοποίηση Σημείου Πώλησης',
        message: `Εγκρίνετε την απενεργοποιήση του συγκεκριμένου Σημείου Πώλησης;`
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          const result1 = await  this.commonService.updateObject(`sale_point/approval_deactivation`,
            {sale_point_id: this.salePoint.id, notification_id: null});
          if (result1) {
            this.matDialog.open(ActionCompletionDialogComponent, {data: {}});
          }
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  async enableSalePoint() {
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: 'Ενεργοποίηση Σημείου Πώλησης',
        message: `Εγκρίνετε την ενεργοποιήση του συγκεκριμένου Σημείου Πώλησης;`
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          const result1 = await  this.commonService.updateObject(`sale_point/reject_deactivation`,
            {sale_point_id: this.salePoint.id, notification_id: null});
          if (result1) {
            this.matDialog.open(ActionCompletionDialogComponent, {data: {}});
          }
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  private openCreateReturnRequestDialog() {
    this.matDialog.open(CreateReturnRequestDialogComponent, {
      data: {
        sale_point_id: this.salePoint.id,
        key_account_id: this.salePoint.key_account_id
      }
    });
  }

  private openRefrigeratorRequestDialog() {
    const dialogReference = this.matDialog.open(CreateRefrigeratorRequestDialogComponent, {
      data: {
        sale_point_id: this.salePoint.id,
        key_account_id: this.salePoint.key_account_id
      }
    });
    dialogReference.afterClosed().subscribe((result) => {
      if (result) {
        this.matDialog.open(ActionCompletionDialogComponent, {data: {}});
      }
    });
  }

  public setCardWidth(): number {
    return this.showEventLogs() ? 66 : 100;
  }

  protected showActions(): boolean {
    return true;
  }

  public showEventLogs(): boolean {
    return this.authService.isUserBelongsTo('basicUser') ||
      this.authService.isUserBelongsTo('transportManager') ||
      this.authService.isUserBelongsTo('customerManager');
  }

}
